/**
 * Posts carousel
 */

 var bp_carousel_init = function(instance) {

  var grid = parseInt(instance.getAttribute('data-grid'));
  var breakpoints,
      slidesPerView,
      spaceBetween;
  if (grid === 2) {
    spaceBetween = 16;
    slidesPerView = 2;
    breakpoints = {
      840: {
        slidesPerView: 1.33,
      },
      99999: {
        slidesPerView: 2,
        allowSlidePrev: false,
        allowSlideNext: false,
        grabCursor: false,
        centeredSlides: false,
      }
    };
  } else if (grid === 3) {
    spaceBetween = 16;
    slidesPerView = 3;
    breakpoints = {
      840: {
        slidesPerView: 1.33,
      },
      1184: {
        slidesPerView: 2,
        noSwiping: false,
        allowSlidePrev: true,
        allowSlideNext: true,
        grabCursor: true,
      },
      99999: {
        slidesPerView: 3,
        allowSlidePrev: false,
        allowSlideNext: false,
        grabCursor: false,
        centeredSlides: false,
      }
    };

  } else {
    spaceBetween = 16;
    slidesPerView = 4;
    breakpoints = {
      840: {
        slidesPerView: 1.33,
      },
      900: {
        slidesPerView: 2.25,
      },
      1000: {
        slidesPerView: 2.75,
      },
      1100: {
        slidesPerView: 3.25,
      },
      1200: {
        slidesPerView: 3.75,
        //noSwiping: false,
        allowSlidePrev: true,
        allowSlideNext: true,
        grabCursor: true,
      },
      99999: {
        slidesPerView: 4,
        allowSlidePrev: false,
        allowSlideNext: false,
        grabCursor: false,
        centeredSlides: false,
      }
    };

  }

  var swiper = new Swiper(instance, {
    direction: 'horizontal',
    loop: false,
    slidesPerView: slidesPerView,
    spaceBetween: spaceBetween,
    noSwiping: true,
    observer: true,
    resizeReInit: true,
    breakpoints: breakpoints,
    centeredSlides: true,
  });

  window.addEventListener("resize", function(){
    setTimeout(function () {

      swiper.slideReset();
      swiper.update();
      swiper.detachEvents();
      swiper.attachEvents();


      // swiper.reInit();

    }, 1000);
  });

};

var bp_carousel = function() {

  var carousel = document.querySelectorAll('.js-carousel');

  for (var i = 0; i < carousel.length; i++) {
    bp_carousel_init(carousel[i]);
  }
};

bp_carousel();
